import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

// models
import { GeneratedRule } from '../../planogram/planogram-edit/components/layout-rules/models/generatedRule';
import { ILayoutRulesData } from '../models/layoutRulesData';
import { LayoutRule } from '../../planogram/planogram-edit/components/layout-rules/models/layoutRule';

// services
import { HttpService } from './http.service';

const BASE_URL: string = 'api/layout/',
	FOLDER_ENDPOINTS: string = `${BASE_URL}rule-folders/`,
	RULE_ENDPOINTS: string = `${BASE_URL}rules/`;

@Injectable()
export class LayoutRulesService {

	public updateRule$: Subject<void> = new Subject<void>();

	constructor(private http: HttpClient, private httpService: HttpService) {}

	createFolder(name: string): Promise<ILayoutRulesData> {
		return this.httpService.getPromise<ILayoutRulesData>(
			this.http.post<ILayoutRulesData>(FOLDER_ENDPOINTS, { name })
		);
	}

	createRule(data: LayoutRule): Promise<ILayoutRulesData> {
		return this.httpService.getPromise<ILayoutRulesData>(
			this.http.post<ILayoutRulesData>(`${RULE_ENDPOINTS}`, data)
		);
	}

	deleteFolder(id: number): Promise<void> {
		return this.httpService.getPromise<void>(
			this.http.delete<void>(`${FOLDER_ENDPOINTS}${id}/`)
		);
	}

	deleteRule(id: number): Promise<void> {
		return this.httpService.getPromise<void>(
			this.http.delete<void>(`${RULE_ENDPOINTS}${id}/`)
		);
	}

	generateRule(text: string, store: number, shelves: number): Observable<GeneratedRule> {
		return this.http.post<GeneratedRule>(
			`${RULE_ENDPOINTS}generate/`,
			{ text: text, shop: store, total_shelves: shelves }
		);
	}

	list(): Promise<Array<ILayoutRulesData>> {
		return this.httpService.getPromise<Array<ILayoutRulesData>>(
			this.http.get<Array<ILayoutRulesData>>(FOLDER_ENDPOINTS)
		);
	}

	updateFolder(id: number, data: { name: string }): Promise<void> {
		return this.httpService.getPromise<void>(
			this.http.patch<void>(`${FOLDER_ENDPOINTS}${id}/`, data)
		);
	}

	updateRule(id: number, data: Partial<LayoutRule>): Promise<ILayoutRulesData> {
		return this.httpService.getPromise<ILayoutRulesData>(
			this.http.patch<ILayoutRulesData>(`${RULE_ENDPOINTS}${id}/`, data)
		);
	}
}